import React, { useState, useEffect, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { documentsActions } from "../../actions/documentsActions"
import { documentsService } from "../../services/documents.services"

const BulkDownload = ({
	docsToSHow,
	activeCheckbox,
	setActiveCheckbox,
	bulkChecked,
	setBulkChecked,
	documentsBulk,
	setDocumentsBulk,
	allChecked,
	setAllChecked,
	isLoading = false,
}) => {
	/* ******************* REDUX STORE ******************* */
	const dispatch = useDispatch()
	const isdownloading = useSelector((state) => state.downloads.bulk_download.downloading)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Documents Bulk Share
	const [documentsBulkShare, setDocumentsBulkShare] = useState("")
	// Show/Hide Bulk buttons
	const [showBtn, setShowBtn] = useState({
		download: true,
		share: true,
	})
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		let docsShare = []
		if (documentsBulk.length > 0) {
			documentsBulk.map((item, i) => {
				if (docsShare.length > 0) {
					// docsShare = docsShare + ',' + item.id;
					docsShare.push(item.id)
				} else {
					// docsShare = item.id;
					docsShare.push(item.id)
				}
			})
		}
		setDocumentsBulkShare(docsShare)
	}, [bulkChecked])

	useEffect(() => {
		setBulkChecked(new Array(docsToSHow.data.length).fill(false))
	}, [docsToSHow])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const updateActiveCheckbox = (item = "") => {
		if (item === "cancel") {
			setDocumentsBulk([])
			setBulkChecked(new Array(docsToSHow.data.length).fill(false))
			setActiveCheckbox(false)
			setShowBtn({
				download: true,
				share: true,
			})
			setAllChecked(false)
		} else if (item === "download") {
			setActiveCheckbox(true)
			setShowBtn({
				download: true,
				share: false,
			})
		} else if (item === "share") {
			setActiveCheckbox(true)
			setShowBtn({
				download: false,
				share: true,
			})
		}
	}

	const downloadBulk = () => {
		if (documentsBulk.length > 0) {
			// doc_id=61c1bfcb01992ca509acdbc9&doc_id=61c1bfcf01992ca509acdcc3
			const documents_id = documentsBulk.map((item) => item.id)
			dispatch(documentsActions.downloadZipAction(documents_id))

			setActiveCheckbox(false)
			setShowBtn({
				download: true,
				share: true,
			})

			setBulkChecked(new Array(docsToSHow.data.length).fill(false))

			let deleteDocument = false
			let indexDoc = ""

			docsToSHow.data.map((item, i) => {
				Object.keys(documentsBulk).map((key, index) => {
					if (documentsBulk[key].id === item.id) {
						deleteDocument = true
						indexDoc = index
					}
				})

				if (deleteDocument) {
					documentsBulk.splice(indexDoc, 1)
				}
			})

			setAllChecked(false)
		}
	}

	const shareBulk = () => {
		setDocumentsBulkShare("")
		setActiveCheckbox(false)
		setShowBtn({
			download: true,
			share: true,
		})

		setBulkChecked(new Array(docsToSHow.data.length).fill(false))

		let deleteDocument = false
		let indexDoc = ""

		docsToSHow.data.map((item, i) => {
			Object.keys(documentsBulk).map((key, index) => {
				if (documentsBulk[key].id === item.id) {
					deleteDocument = true
					indexDoc = index
				}
			})

			if (deleteDocument) {
				documentsBulk.splice(indexDoc, 1)
			}
		})
		setAllChecked(false)
	}

	const checkDocumentsBulkShare = async () => {
		let response = ""
		let token = ""
		if (documentsBulkShare != "") {
			response = await documentsService.shareDocument(documentsBulkShare)
			token = Object.keys(response.data.token)[0]
		}
		if (token != "") {
			window.location = `mailto:?subject=Anzyz Project – Shared Document&body=Please, download this set of documents: ${window.location.protocol}//${window.location.host}/downloads?downloads=${token}`
			shareBulk()
		}
		// if (documentsBulkShare != ''){
		//     window.location = `mailto:?subject=Anzyz Project – Shared Document&body=Please, download this set of documents: ${window.location.protocol}//${window.location.host}/downloads?downloads=${documentsBulkShare}`;
		//     shareBulk();
		// }
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	return (
		<Fragment>
			<div className="row">
				<div className="col-12">
					<div className="col-3 float-end d-flex justify-content-center bulkDownload">
						<div className="col-12 divBlock divBtnBulk">
							<div className="divBlock px-2">
								<button
									className={showBtn.download ? "btn btn-sm btn-primary" : "btn btn-sm btn-primary hidden"}
									onClick={(e) => {
										e.preventDefault()
										updateActiveCheckbox("download")
										downloadBulk()
									}}
									disabled={isdownloading}
								>
									{isdownloading ? "Downloading..." : "Bulk Download"}
								</button>
							</div>
							{/* Commenting following code and not removing as this may be referred in the future */}
							{/* <div className="divBlock px-2">
                            <button
                                className={showBtn.share ? "btn btn-sm btn-primary" : "btn btn-sm btn-primary hidden"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    updateActiveCheckbox('share');
                                    checkDocumentsBulkShare();
                                }}
                            >
                                Bulk Share
                            </button>
                        </div> */}
							<div className="divBlock px-2">
								{activeCheckbox ? (
									<button
										className="btn btn-sm btn-primary"
										onClick={(e) => {
											e.preventDefault()
											updateActiveCheckbox("cancel")
										}}
									>
										Cancel
									</button>
								) : null}
							</div>
						</div>
					</div>
				</div>
				<div className="col-12 divBlock mt-2">
					<div className="col-3 float-end d-flex justify-content-center">
						<div className="col-12 divBlock">
							<div className="divBlock px-2">{activeCheckbox ? <small>*Select documents to download</small> : null}</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default BulkDownload
